
import React from 'react';
import { Event } from '@/lib/types';
import EventList from '../EventList';
import { motion } from 'framer-motion';
import { getUpcomingEvents } from '@/lib/eventFilters';
import { Award } from 'lucide-react';

interface RecommendedEventsSectionProps {
  events?: Event[];
  isLoading?: boolean;
  title?: string;
  onEventClick?: (event: Event) => void;
}

const RecommendedEventsSection: React.FC<RecommendedEventsSectionProps> = ({
  events = [],
  isLoading = false,
  title = "Ajánlott események számodra",
  onEventClick
}) => {
  return (
    <motion.section 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="py-12 font-sans bg-gradient-to-b from-white to-medihub-primary/5 rounded-3xl my-8 shadow-sm"
    >
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <div className="flex items-center gap-3">
            <div className="bg-medihub-accent/10 p-2 rounded-full">
              <Award className="h-6 w-6 text-medihub-accent" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          </div>
          <p className="text-gray-600 mt-2 ml-11">Ezek az események érdekesek lehetnek számodra</p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 shadow-md">
          <EventList 
            events={events} 
            limit={6} 
            showFilters={false} 
            loading={isLoading || events.length === 0}
            onEventClick={onEventClick}
          />
        </div>
        
        <div className="mt-6 text-right">
          <a 
            href="/calendar" 
            className="text-medihub-accent hover:underline font-medium inline-flex items-center"
          >
            Összes esemény megtekintése
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default RecommendedEventsSection;
